import { ThemeProvider } from 'styled-components';

import ConfigProviderAntd from './theme/config/ProviderAntd';
import GlobalStyles from './theme/globalStyles';
import { theme } from './theme/theme';
import './theme/tokens.css';
import './theme/ant-overrides.css';

import QueryProvider from './lib/QueryProvider';
import AppRoutes from './routes';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <ConfigProviderAntd>
        <QueryProvider>
          <GlobalStyles />
          <AppRoutes />
        </QueryProvider>
      </ConfigProviderAntd>
    </ThemeProvider>
  );
}

export default App;
